if (!customElements.get('mini-variant-picker')) {
  customElements.define(
    'mini-variant-picker',
    class MiniVariantPicker extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', this.onVariantChange.bind(this));
      }

      onVariantChange(event) {
        if (!event.target.classList.contains('mini-variant-picker__radio')) return;
        var radio = event.target;
        var variantId = radio.value;

        var input = this.querySelector('.mini-variant-picker__input');
        if (input) input.value = variantId;

        var template = this.querySelector('template[data-variant-price-id="' + variantId + '"]');
        var priceTargetId = this.getAttribute('data-price-target');
        var priceTarget = priceTargetId ? document.getElementById(priceTargetId) : null;
        if (template && priceTarget) {
          priceTarget.innerHTML = template.innerHTML;
        }

        var onSale = radio.getAttribute('data-on-sale') === 'true';
        var discountPercent = radio.getAttribute('data-discount-percent') || '0';

        var discountBadgeId = this.getAttribute('data-discount-badge-target');
        var discountBadge = discountBadgeId ? document.getElementById(discountBadgeId) : null;
        if (discountBadge) {
          discountBadge.style.display = onSale ? '' : 'none';
          if (onSale) discountBadge.textContent = '-' + discountPercent + '%';
        }

        var saleBadgeIds = (this.getAttribute('data-sale-badge-targets') || '').split(' ');
        var saleBadgeLabel = this.getAttribute('data-sale-badge-label') || '';
        saleBadgeIds.forEach(function (id) {
          if (!id) return;
          var el = document.getElementById(id);
          if (!el) return;
          el.style.display = onSale ? '' : 'none';
          if (onSale) el.textContent = saleBadgeLabel;
        });
      }
    }
  );
}
